import React, { useEffect, useState } from "react";
import { useTable } from "react-table";
import StockedItems from "../../components/Other/StockedItems";

const MillScanner = () => {
  const [woNumber, setWoNumber] = useState("");
  const [woStatus, setWoStatus] = useState(null);
  const [poNumbers, setPoNumbers] = useState([]);
  const [poInfo, setPoInfo] = useState({});
  const [flag, setFlag] = useState(false);
  let allDocuments = [];

  const getPoNumbers = () => {
    setPoNumbers([]);
    return fetch(`/api/cloud/mill/getWOinfo?wo=${woNumber}`)
      .then((response) => response.json())
      .then((responseJson) => {
        responseJson.recordset.map((doc) => {
          allDocuments.push(doc.DocumentNumber);
        });
        setPoNumbers(allDocuments);
      })
      .catch((error) => {
        //console.error(error);
      });
  };

  const getWOStatus = () => {
    return fetch(`/api/cloud/mill/getWOStatus?wo=${woNumber}`)
      .then((response) => response.json())
      .then((responseJson) => {
        setWoStatus(responseJson.recordset);
      })
      .catch((error) => {
        //console.error(error);
      });
  };

  const getPOInfo = (po) => {
    return fetch(`/api/cloud/mill/getPOLines?poNum=${po}`)
      .then((response) => response.json())
      .then((responseJson) => {
        setPoInfo((prevInfo) => ({
          ...prevInfo,
          [po]: responseJson.recordset, // Store each `po`'s data under its own key
        }));
      })
      .catch((error) => {
        //console.error(error);
      });
  };

  useEffect(() => {
    if (poNumbers.length > 0 && !flag) {
      setFlag(false);
      poNumbers.forEach((number) => {
        getPOInfo(number);
      });
    }
  }, [poNumbers]);

  //   useEffect(() => {
  //     console.log(poInfo);
  //   }, [poInfo]);

  const POTable = ({ columns, data }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <div className="app-card mb-5 overflow-hidden rounded-2xl border">
        <div className="overflow-x-auto">
          <table {...getTableProps()} className="app-table text-base">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} className="!text-sm">
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                const isReceived = row.original["Line Status"] === "Received";

                return (
                  <tr
                    className={
                      isReceived
                        ? "bg-emerald-500/15 text-emerald-900 dark:text-emerald-100"
                        : "bg-orange-500/15 text-orange-900 dark:text-orange-100"
                    }
                    {...row.getRowProps()}
                  >
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()} className="w-32">
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const POContainer = ({ data }) => {
    const columns = React.useMemo(
      () => [
        { Header: "Line Number", accessor: "LineNumber" },
        { Header: "Product Code", accessor: "ProductCode" },
        { Header: "Description", accessor: "Description" },
        { Header: "Line Status", accessor: "Line Status" },
        { Header: "Rcv'd On", accessor: "Rcv'd On" },
        { Header: "QTY", accessor: "QTY" },
        { Header: "Bin Location", accessor: "BinLocation" },
        {
          Header: "Date Expected",
          accessor: "DateExpected",
          Cell: ({ value }) => {
            const date = new Date(value);

            if (isNaN(date) || date.getFullYear() === 1969) {
              return "No Date Available";
            }
            return date.toLocaleDateString();
          },
        },
      ],
      []
    );

    return (
      <div className="flex flex-col w-full">
        {Object.keys(data).map((poNumber) => (
          <div className="flex w-full flex-col" key={poNumber}>
            <h2 className="mb-2 text-lg font-bold tracking-tight">
              PO Number: {poNumber}
            </h2>
            <POTable columns={columns} data={data[poNumber]} />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="app-page flex min-h-screen w-full flex-col">
      <div className="flex w-full gap-3 p-4">
        <input
          type="text"
          value={woNumber}
          onChange={(e) => setWoNumber(e.target.value)}
          placeholder="Scan/Type Works Order"
          aria-label="Works order number"
          className="app-input h-16 w-full min-w-0 flex-1 rounded-2xl border px-5 text-xl"
        ></input>
        <button
          type="button"
          onClick={() => {
            setWoStatus(null);
            setPoNumbers([]);
            setPoInfo({});
            getPoNumbers();
            getWOStatus();
          }}
          className="h-16 w-32 shrink-0 rounded-2xl bg-emerald-600 text-xl font-bold text-white shadow-sm transition-colors hover:bg-emerald-700 active:bg-emerald-800"
        >
          Go!
        </button>
      </div>

      {woStatus && (
        <>
          <div className="px-4">
            <div className="app-card rounded-2xl border p-5">
              <p className="text-2xl font-bold tracking-tight">
                Work Order {woNumber}
              </p>
              <div className="mt-2 flex flex-wrap justify-between gap-x-6 gap-y-1 text-base">
                <p>
                  <span className="app-muted">Desc:</span>{" "}
                  {woStatus[0].Description[0]}
                </p>
                <p>
                  <span className="app-muted">Date Required:</span>{" "}
                  {new Date(woStatus[0].DateRequired).toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>

          <div className="flex w-full p-4">
            <POContainer data={poInfo} />
          </div>

          <div className="flex w-full px-4 pb-6">
            <StockedItems woStatus={woStatus} />
          </div>
        </>
      )}
    </div>
  );
};

export default MillScanner;
